import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import Link from 'corp/components/UI/IsomorphicLink/IsomorphicLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { makeStyles } from 'design-system/styles';

type ClassNameKey = 'link';

interface SidebarLinkProps {
  href: string;
  target?: string;
  inline?: boolean;
  rel?: string;
  dirLink?: string;
  classes?: Record<ClassNameKey, string>;
  children?: React.ReactNode;
}

const SidebarLink: React.FC<SidebarLinkProps> = (props: SidebarLinkProps) => {
  const classes = useStyles();

  const isAbsolute = _.startsWith(props.href, 'http');

  return (
    <div className={classNames(classes.item, { [classes.inline]: props.inline })}>
      {isAbsolute && (
        <a
          href={props.href}
          rel={props.rel}
          target={props.target}
          className={classNames(classes.isomorphicLink, props.classes?.link)}
        >
          {props.children}
        </a>
      )}
      {!isAbsolute && (
        <Link
          href={trimPrefix(props.href, '/corp')}
          rel={props.rel}
          target={props.target}
          className={classNames(classes.isomorphicLink, props.classes?.link)}
        >
          {props.children}
        </Link>
      )}
      {props.dirLink && (
        <a
          href={props.dirLink}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.dirLink}
        >
          <FontAwesomeIcon icon="info-circle" style={{ marginLeft: '5px' }} />
        </a>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  item: {
    fontSize: '14px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    '&:hover $dirLink': {
      visibility: 'visible',
    },
    '&:hover $isomorphicLink': {
      borderBottom: '1px solid var(--color-ScaleBlue)',
      background: 'rgba(0, 0, 0, 0.1)',
    },
    width: '240px',
    maxWidth: '240px',
    boxSizing: 'border-box',
  },
  inline: {
    display: 'inline',
  },
  isomorphicLink: {
    fontWeight: 500,
    maxWidth: '200px',
    transition: 'opacity 0.2s',
    opacity: 1,
    '&:hover': {
      opacity: 0.8,
    },
    borderBottom: '1px solid #dddddd',
  },
  dirLink: {
    color: 'var(--color-RemoGray50)',
    marginLeft: 4,
    visibility: 'hidden',
  },
});

function trimPrefix(value: string, prefix: string): string {
  if (_.startsWith(value, prefix)) {
    return value.replace(prefix, '');
  } else {
    return value;
  }
}

export default SidebarLink;
